import { atom } from "recoil";

//전역변수
export const HeaderAtom = atom({
    key: 'HeaderAtom',
    default: 0,
});
